export enum GeoSeachType {
    circle = 'Circle',
    boundingBox = 'BoundingBox',
    multipolygon = 'Multipolygon',
    boundingBoxAndCircle = 'BoundingBoxAndCircle',
}
